import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { useUserRole } from "../hooks/useUserRole";

// El rol CLIENT tiene su propia app: inicio, campaña, subcampaña y ajustes.
// Estas piezas deciden qué pantalla ve cada rol sin tocar las de los demás.

const CLIENT_PATHS = [
  /^\/$/,
  /^(?:\/client)?\/campaigns\/[^/]+$/,
  /^(?:\/client)?\/campaigns\/[^/]+\/subcampaigns\/[^/]+$/,
  /^\/settings$/,
  /^\/mcp\/authorize$/,
];

/** Rutas a las que puede entrar un cliente; el resto es un 404 para él. */
export const isClientPath = (pathname: string): boolean =>
  CLIENT_PATHS.some((pattern) => pattern.test(pathname));

/** La pantalla de cliente para el rol CLIENT y la de siempre para el resto. */
export const ClientSwitch: React.FC<{
  client: React.ReactElement;
  children: React.ReactElement;
}> = ({ client, children }) => {
  const { isClient } = useUserRole();
  return isClient ? client : children;
};

/** La subcampaña solo existe en la vista de cliente: el resto va a la campaña. */
export const ToParentCampaign: React.FC = () => {
  const { campaignId } = useParams<{ campaignId: string }>();
  return <Navigate to={`/campaigns/${campaignId}`} replace />;
};
